import Page from './Page';

export { default as Header } from './Header';

export default Page;
